import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MessageBox from '../../common/components/MessageBox';
import FontAwesome from 'react-fontawesome';
import { withNamespaces } from 'react-i18next';

class DeleteButton extends Component {
	constructor(props) {
		super(props);
		this.showConfirmation = this.showConfirmation.bind(this);
		this.hideConfirmation = this.hideConfirmation.bind(this);
		this.state = { showConfirmation: false };
	}

	showConfirmation() {
		this.setState({ showConfirmation: true });
	}

	hideConfirmation() {
		this.setState({ showConfirmation: false });
	}

	render() {
		const { t, onDelete, confirmationTitle, confirmationMessage, label, hideIcon, className } = this.props;
		return <React.Fragment>
			<a role='button' className={className} onClick={this.showConfirmation}>{!hideIcon && <FontAwesome name='remove' />} {label ? label : t('Common_Delete')}</a>
			<MessageBox
				show={this.state.showConfirmation}
				title={confirmationTitle}
				message={confirmationMessage}
				onConfirm={() => {
					this.hideConfirmation();
					onDelete();
				}}
				onCancel={this.hideConfirmation}
			/>
		</React.Fragment>;
	}
}

DeleteButton.propTypes = {
	onDelete: PropTypes.func,
	confirmationTitle: PropTypes.string,
	confirmationMessage: PropTypes.string,
	label: PropTypes.node
};

export default withNamespaces()(DeleteButton);